import type { IconName } from './icons'

/*
 * The fixed copy on the page. Every line here describes something the product
 * does today — apps/web's landing page holds the same rule, and for the same
 * reason: a marketplace that promises a feature is a business's customers
 * asking them for it.
 */

/** Rotated through the search box's placeholder. */
export const EXAMPLES = [
  'I need a haircut near Baner tomorrow under ₹800…',
  'Find a dentist near me…',
  'I need a photographer for my wedding…',
  'Find a gym under ₹2,000 a month…',
  'I need AC repair today…',
]

export const STEPS: [string, string][] = [
  ['Tell us what you need', 'Describe your requirement in your own words.'],
  ['Blooq finds the right options', 'We match what you asked for with businesses, services, area, price and free times.'],
  ['Compare', 'See services, prices and the next free times side by side.'],
  ['Book or enquire', 'Book in the business’s own app, or send them an enquiry.'],
]

export const BENEFITS: [string, string, string][] = [
  ['Get discovered', 'Appear when customers search for businesses like yours.', 'p0'],
  ['Get customers', 'Receive bookings and enquiries from Blooq customers.', 'p1'],
  ['Manage bookings', 'Manage services, pricing, availability and bookings.', 'p2'],
  ['Grow with AI', 'Let AI help customers understand your business and book with you.', 'p3'],
]

export const FEATURES: [string, IconName][] = [
  ['Business profile', 'store'],
  ['Services & pricing', 'tag'],
  ['Availability', 'calendar'],
  ['Bookings', 'check'],
  ['Enquiries', 'message'],
  ['AI assistant', 'sparkles'],
  ['Website widget', 'code'],
  ['Analytics', 'chart'],
  ['Team members', 'users'],
]

/** What a business gets, in the "list your business" dialog. */
export const OFFERS: [IconName, string, string][] = [
  ['search', 'Get discovered', 'Appear when customers search for businesses like yours.'],
  ['users', 'Get customers', 'Receive bookings and enquiries from Blooq customers.'],
  ['store', 'Your own booking app', 'A branded app at your own address, with a printable QR code.'],
  ['calendar', 'Run it from one dashboard', 'Services, prices, hours, bookings and enquiries in one place.'],
  ['sparkles', 'AI assistant and website widget', 'Answers customers from your own FAQs, in your app or as a chat bubble on your site.'],
  ['chart', 'Know how it is going', 'Bookings over time, no-shows and your busiest slots.'],
]

/** Tapping one searches for it, so each is phrased the way a customer types. */
export const INDUSTRIES: string[] = [
  'Salon & Spa',
  'Dental clinic',
  'Restaurants & Cafés',
  'Gym & Yoga',
  'Car service',
  'Home repairs',
  'Real estate',
  'Lawyer & CA',
  'Hotels & Stays',
  'Photography',
  'Wedding & Events',
  'Travel & Tours',
  'Vet & Pet care',
  'Coaching & Tuition',
  'Financial advisor',
  'Insurance',
  'Cleaning',
  'Pest control',
  'Coworking',
  'Solar',
  'Courier',
  'Recruitment',
]
